var path = '/configuration/formEditor/formEditor.tpl.html';
var html = "<div class=\"formEditor\">\n\n    <ui-form-editor-header></ui-form-editor-header>\n\n    <ui-form-editor-nav></ui-form-editor-nav>\n\n    <div class=\"content\" ui-view=\"tabView\"></div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;